module.exports = "https://cdn.hellotech.com/client-assets/security_cameras_tablet_73d03ad36593ce81375228d506407a30.webp";